
namespace RioERP.Orders {
    export class OrdershippingBooksColumns {
        static columnsKey = 'Orders.OrdershippingBooks';
    }
}